import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-gps"
    ,templateUrl: "./icon.gps.component.html"
    ,styleUrls: ["./icon.gps.component.scss"]
})
export class IconGpsComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() dtgGpsStatus:any = "N";
    itemColor:string = "badge-danger";
    textTooltip:string = "GPS상태";

    constructor(){

    }

    ngOnInit() {
        let textTooltipAppend = "수신불량";
        switch(this.dtgGpsStatus){
            case "N":
            case "n":
                this.itemColor = "badge-dark";
                textTooltipAppend = "단선";
                break;
            case "V":
            case "v":
                this.itemColor = "badge-danger";
                textTooltipAppend = "수신불량";
                break;
            case "A":
            case "a":
                this.itemColor = "badge-warning";
                textTooltipAppend = "신호약함";
                break;
            case "P":
            case "p":
            case "G":
            case "g":
                this.itemColor = "badge-success";
                textTooltipAppend = "정상";
                break;
            default:
                //미확인
                this.itemColor = "badge-secondary";
                textTooltipAppend = "미확인";
                break;
        }
        this.textTooltip = `GPS상태 (${textTooltipAppend})`;
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }

    // @Input()
    // set val(gpsStatus:string) {
    //     if(gpsStatus){
    //         this.gpsStatus = gpsStatus.toUpperCase();
    //         let textTooltipAppend = "수신불량";

    //         switch(gpsStatus){
    //             case "N":
    //                 this.itemColor = "badge-dark";
    //                 textTooltipAppend = "단선";
    //                 break;
    //             case "V":
    //                 this.itemColor = "badge-danger";
    //                 textTooltipAppend = "수신불량";
    //                 break;
    //             case "A":
    //                 this.itemColor = "badge-warning";
    //                 textTooltipAppend = "신호약함";
    //                 break;
    //             case "P":
    //             case "G":
    //                 this.itemColor = "badge-success";
    //                 textTooltipAppend = "정상";
    //                 break;
    //             default:
    //                 //미확인
    //                 this.itemColor = "badge-secondary";
    //                 textTooltipAppend = "미확인";
    //                 break;
    //         }

    //         this.textTooltip = `GPS상태 (${textTooltipAppend})`;
    //     }
    // }
}